import { render, staticRenderFns } from "./QAgentStickyNotes.vue?vue&type=template&id=47e12280&"
import script from "./QAgentStickyNotes.vue?vue&type=script&lang=js&"
export * from "./QAgentStickyNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports